import type { Translations } from "../../types";
import { buildings } from "./buildings";
import { buildingDetail } from "./buildingDetail";
import { esg } from "./esg";
import { technical } from "./technical";
import { documents } from "./documents";
import { forms } from "./forms";
import { common } from "./common";
import { session } from "./session";
import { help } from "./help";
import { fireSafetyEmptyState } from "./fireSafetyEmptyState";
import { auth } from "./auth";
import { settings } from "./settings";
import { projects } from "./projects";
import { timeline } from "./timeline";
import { budget } from "./budget";
import { buildingUsers } from "./buildingUsers";
import { pm } from "./pm";
import { signing } from "./signing";
import { brief } from "./brief";
import { contacts } from "./contacts";
import { tools } from "./tools";
import { messages } from "./messages";
import { buildingDataSummary } from "./buildingDataSummary";
import { billing } from "./billing";
import { connectors } from "./connectors";
import { pageInfo } from "./pageInfo";

// Estonian translations
const translations: Translations = {
  common: {
    ...common,
    dashboard: "Töölaud", // Adding missing dashboard property
  },
  buildings,
  buildingDetail,
  esg,
  technical,
  documents,
  forms,
  session,
  help,
  fireSafetyEmptyState,
  auth,
  settings,
  projects,
  timeline,
  budget,
  buildingUsers,
  pm,
  signing,
  brief,
  contacts,
  tools,
  messages,
  buildingDataSummary,
  billing,
  connectors,
  pageInfo,
  // Add the SignUp translations
  signUp: {
    title: "Registreeru",
    description: "Loo konto alustamiseks",
    joinOrganization: "Liitu {organization}",
    checkingExistingOrganizations: "Kontrollin olemasolevaid organisatsioone…",
    creatingAccount: "Loon kontot…",
    email: "E-posti aadress",
    password: "Parool",
    firstName: "Eesnimi",
    lastName: "Perekonnanimi",
    organizationName: "Organisatsiooni nimi",
    organizationDomain: "Organisatsiooni domeen",
    terms: "Nõustun kasutustingimustega",
    termsLink: "tingimused",
    submit: "Registreeru",
    alreadyHaveAccount: "Konto juba olemas?",
    login: "Logi sisse",
    success: "Õnnestus",
    successDescription: "Konto on loodud. Saate nüüd sisse logida.",
    errorDescription: "Viga konto loomisel. Palun proovige uuesti.",
    cleanupNoticeTitle: "Konto puhastamine",
    cleanupNoticeDescription:
      "Leidsime pooleli jäänud konto loomise ja puhastasime selle. Nüüd saate uuesti registreeruda.",
    invalidInviteMessage: "Kutse link on vigane või aegunud.",
  },
  // Legacy field mappings
  buildingSections: buildings.buildingSections,
  finishes: buildings.finishes,
  structuralMaterials: buildings.structuralMaterials,
  fireSafety: buildings.fireSafety,
  roomsSection: buildings.roomsSection,
};

export default translations;
export const et = translations;
